@for (notification of notificationService.notifications$ | async; track $index) {
<app-notification [notification]="notification"></app-notification>
}

<div class="min-h-screen text-white">
  <router-outlet></router-outlet>
</div>